import { useState, useEffect } from 'react';
import butterflyApi from '../ButterflyApi';

const Script = () => {
  const queryParams = new URLSearchParams(window.location.search)
  const scriptNo = queryParams.get("scriptNo")
  const heroNo = queryParams.get("heroNo")

  const [title, setTitle] = useState('')
  const [summary, setSummary] = useState('')
  const [instagram, setInstagram] = useState('')
  const [script, setScript] = useState('')
  const [mainImageUrl, setMainImageUrl] = useState('')
  const [imageTags, setImageTags] = useState('')
  const [use, setUse] = useState(false)
  const [hot, setHot] = useState(false)
  const [scripts, setScripts] = useState([])
  const [promptHeroNo, setPromptHeroNo] = useState(heroNo || '1')

  const [promptResult, setPromptResult] = useState('')
  const [imagePromptResult, setImagePromptResult] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const loadScripts = async () => {
      const data = await butterflyApi.getManageScripts()
      if (data) setScripts([...data].reverse())
    }
    loadScripts()
  }, [])

  useEffect(() => {
    if (!scriptNo) return
    const load = async () => {
      setLoading(true)
      const data = await butterflyApi.getScript(scriptNo)
      if (data) {
        setTitle(data.title || '')
        setSummary(data.summary || '')
        setInstagram(data.instagram || '')
        setScript(data.script || '')
        setMainImageUrl(data.mainImageUrl || '')
        setImageTags(data.imageTags || '')
        setUse(data.use || false)
        setHot(data.hot || false)
      }
      setLoading(false)
    }
    load()
  }, [scriptNo])

  const save = async () => {
    setLoading(true)
    if (scriptNo) {
      await butterflyApi.updateScript(scriptNo, title, summary, instagram, script, mainImageUrl, use, hot, imageTags)
      alert('저장되었습니다.')
    } else {
      await butterflyApi.createScript(title, summary, instagram, script, mainImageUrl, use, hot, imageTags)
      alert('추가되었습니다.')
      window.location.href = '/manage'
    }
    setLoading(false)
  }

  const checkPrompt = async () => {
    if (!scriptNo) return
    setLoading(true)
    const data = await butterflyApi.getScriptPrompt(scriptNo, false, promptHeroNo)
    setPromptResult(data || '')
    setLoading(false)
  }

  const generateStory = async () => {
    if (!scriptNo) return
    if (!window.confirm('동화를 생성하시겠습니까?')) return
    setLoading(true)
    await butterflyApi.getScriptPrompt(scriptNo, true, promptHeroNo)
    setLoading(false)
    alert('동화 생성이 완료되었습니다.')
    window.location.href = `/manage?heroNo=${promptHeroNo}&scriptNo=${scriptNo}`
  }

  const checkImagePrompt = async () => {
    if (!scriptNo) return
    setLoading(true)
    const data = await butterflyApi.getImagePrompt(promptHeroNo, scriptNo)
    setImagePromptResult(data || '')
    setLoading(false)
  }

  const selectScript = (no) => {
    window.location.href = `/manage/script?scriptNo=${no}`
  }

  return <div className="px-4 mt-12 max-w-2xl">
    <div className="mb-4">
      <a href="/manage" className="text-blue-600 underline">Manage</a>
    </div>
    <div className="text-lg font-bold mb-4">{scriptNo ? `Script 수정 (No: ${scriptNo})` : 'Script 추가'}</div>

    {loading && <div className="text-gray-500 mb-4">로딩중...</div>}

    <div className="mb-4">
      <label className="block font-semibold text-sm mb-1">Title</label>
      <input type="text" className="w-full border rounded p-2" value={title} onChange={e => setTitle(e.target.value)} />
    </div>

    <div className="mb-4">
      <label className="block font-semibold text-sm mb-1">Summary</label>
      <textarea className="w-full border rounded p-2" rows={4} value={summary} onChange={e => setSummary(e.target.value)} />
    </div>

    <div className="mb-4">
      <label className="block font-semibold text-sm mb-1">Instagram</label>
      <input type="text" className="w-full border rounded p-2" value={instagram} onChange={e => setInstagram(e.target.value)} />
    </div>

    <div className="mb-4">
      <label className="block font-semibold text-sm mb-1">Script</label>
      <textarea className="w-full border rounded p-2" rows={10} value={script} onChange={e => setScript(e.target.value)} />
    </div>

    <div className="mb-4">
      <label className="block font-semibold text-sm mb-1">Main Image URL</label>
      <input type="text" className="w-full border rounded p-2" value={mainImageUrl} onChange={e => setMainImageUrl(e.target.value)} />
    </div>

    <div className="mb-4">
      <label className="block font-semibold text-sm mb-1">Image Tags</label>
      <input type="text" className="w-full border rounded p-2" value={imageTags} onChange={e => setImageTags(e.target.value)} />
    </div>

    <div className="mb-4 flex gap-6">
      <label className="flex items-center gap-2 font-semibold text-sm">
        <input type="checkbox" checked={use} onChange={e => setUse(e.target.checked)} />
        사용여부
      </label>
      <label className="flex items-center gap-2 font-semibold text-sm">
        <input type="checkbox" checked={hot} onChange={e => setHot(e.target.checked)} />
        인기글여부
      </label>
    </div>

    <div className="flex gap-3 mb-4">
      <button className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600" onClick={save} disabled={loading}>
        저장
      </button>
    </div>
    <div className="flex gap-3">
      {scriptNo && <>
        <input type="number" className="border rounded p-2 w-20" value={promptHeroNo} onChange={e => setPromptHeroNo(e.target.value)} />
        <button className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600" onClick={checkPrompt} disabled={loading}>
          prompt 확인
        </button>
        <button className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600" onClick={checkImagePrompt} disabled={loading}>
          imagePrompt 확인
        </button>
        <button className="bg-green-500 text-white px-6 py-2 rounded hover:bg-green-600" onClick={generateStory} disabled={loading}>
          동화생성
        </button>
      </>}
    </div>

    {promptResult && <div className="mt-4 p-4 bg-gray-50 border rounded whitespace-pre-wrap text-sm relative">
      <button className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" onClick={() => setPromptResult('')}>X</button>
      {promptResult}
    </div>}

    {imagePromptResult && <div className="mt-4 p-4 bg-gray-50 border rounded whitespace-pre-wrap text-sm relative">
      <button className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" onClick={() => setImagePromptResult('')}>X</button>
      <div className="font-bold mb-2">Image Prompt</div>
      {imagePromptResult}
    </div>}

    <div className="mt-12">
      <div className="text-lg font-bold mb-4">Script 목록</div>
      {scripts.map(s => (
        <div key={s.scriptNo} className="border rounded p-3 mb-2 cursor-pointer hover:bg-blue-50" onClick={() => selectScript(s.scriptNo)}>
          <div className="font-semibold">{s.title} <span className="text-gray-400 text-sm">(No: {s.scriptNo})</span></div>
          {s.summary && <div className="text-sm text-gray-600 truncate">{s.summary}</div>}
        </div>
      ))}
    </div>

    <div className='mt-12 mb-4 text-sm'>
      #가족들
      #나이많은가족1
      #나이많은가족2
      #나이많은가족3
      #엄마
      #아빠
      #할머니할아버지1
      #할머니할아버지2
      #가족1
      #가족2
      #가족3
      #가족4
      #가족5
      #형누나언니오빠1
      #형누나언니오빠2
      #형누나언니오빠3
      #동생1
      #동생2
      #동생3
      #형제1
      #형제2
      #형제3
      #형제들
      #친구1
      #친구2
      #친구3
      #강아지1
      #강아지2
      #고양이1
      #고양이2
      #반려동물1|강아지
      #반려동물2
    </div>
  </div>
}

export default Script
